import qs from 'qs';
import { network } from 'services/network';

export const getSubProgramPreferenceImportance = ({ subProgramId }) => {
    const querystring = qs.stringify({ subProgramId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSubProgramPreferenceImportance${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
